import React from 'react';
import { Select, Form } from 'antd';
import filterConnect from '../../../../../../../common/hoc/filterConnect';

const Option = Select.Option;

const DocumentTypes = ({ form, documentsTypes }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Документ:">
      {getFieldDecorator('documentTypes')(
        <Select
          style={{ width: '100%' }}
          allowClear={true}
          className="ui-select"
          mode="multiple"
          name="documentTypes"
          placeholder="Выберите документ"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {documentsTypes &&
            documentsTypes.map(type => (
              <Option key={type.documentTypeKey} value={type.documentTypeKey}>
                {type.documentTypeName}
              </Option>
            ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default filterConnect(DocumentTypes, ['documentsTypes']);
